interface OutputObject {
  liveFeedId: string;
  url: string;
  title: string;
  description: string | null;
  network: string;
  imageThumbUrl: string | null;
  imageFullUrl: string | null;
  imageIconUrl: string | null;
  isUnlocked: boolean;
  isUnlockedByLocalNow: boolean;
}

interface InputObject {
  experiences: [];
  linearFeeds: LinearFeed[];
}

interface LinearFeed {
  feedName: string;
  bannerOverlayText: string;
  appText: string;
  appDescription: string | null;
  hlsUrl: string;
  dashUrl: string;
  isEnabled: boolean;
  videoIntro: Video;
  videoOutro: Video;
  imageUrl: string | null;
  thumbnailUrl: string | null;
  iconUrl: string | null;
}

interface Video {
  network: string | null;
  assetId: string | null;
}

export const transformObjectWithLinearFeedsToANF = (input: InputObject): OutputObject[] =>
  input.linearFeeds.map((feed: LinearFeed) => ({
    liveFeedId: feed.feedName,
    url: feed.hlsUrl,
    title: feed.appText,
    description: feed.appDescription,
    network: 'TWC',
    imageThumbUrl: feed.thumbnailUrl,
    imageFullUrl: feed.imageUrl,
    imageIconUrl: feed.iconUrl,
    isUnlocked: feed.isEnabled,
    isUnlockedByLocalNow: false,
  }));
